import { FC, type JSX } from 'react';

import SideDrawer from '@payaca/components/sideDrawer/SideDrawer';
import TaskReadCompleteView from '../taskReadCompleteView/TaskReadCompleteView';

type Props = {
  taskId?: number;
  hideDealLink?: boolean;
  onDeleteTaskSuccess?: () => void;
  onUpdateTaskSuccess?: () => void;
  isOpen: boolean;
  onClose?: () => void;
};

const TaskReadCompleteDrawer: FC<Props> = ({
  taskId,
  hideDealLink,
  onDeleteTaskSuccess,
  onUpdateTaskSuccess,
  isOpen,
  onClose,
}: Props): JSX.Element | null => {
  return (
    <SideDrawer
      isOpen={isOpen}
      onClose={onClose}
      className="task-read-complete-drawer"
    >
      {taskId && (
        <TaskReadCompleteView
          taskId={taskId}
          onDeleteTaskSuccess={() => {
            if (onClose) {
              // oxlint-disable-next-line typescript-eslint(no-meaningless-void-operator) -- FIXME: pre-existing error: void operator shouldn't be used on void; it should convey that a return value is being ignored
              void onClose();
            }
            if (onDeleteTaskSuccess) {
              // oxlint-disable-next-line typescript-eslint(no-meaningless-void-operator) -- FIXME: pre-existing error: void operator shouldn't be used on void; it should convey that a return value is being ignored
              void onDeleteTaskSuccess();
            }
          }}
          onUpdateTaskSuccess={onUpdateTaskSuccess}
          hideDealLink={hideDealLink}
        />
      )}
    </SideDrawer>
  );
};
export default TaskReadCompleteDrawer;
